var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('notifications'),_c('DashboardLayout',{attrs:{"menuList":_vm.menuList,"user":_vm.userName},on:{"userDropdown":_vm.handleClickUserDropdown}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }